var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ia-cliente-alocacao", on: { mouseleave: _vm.desfocar } },
    [
      _c(
        "div",
        { staticClass: "ia-cliente-alocacao__barra" },
        _vm._l(_vm.pedacos, function(pedaco) {
          return _c("button", {
            key: pedaco.chave,
            staticClass: "ia-cliente-alocacao__pedaco",
            style: pedaco.estilo,
            attrs: {
              type: "button",
              title: pedaco.titulo,
              "aria-label": pedaco.titulo
            },
            on: {
              mouseenter: function($event) {
                return _vm.focar(pedaco.indice)
              },
              focus: function($event) {
                return _vm.focar(pedaco.indice)
              },
              blur: _vm.desfocar
            }
          })
        }),
        0
      ),
      _vm.rotuloEmFoco
        ? _c(
            "span",
            { staticClass: "ia-cliente-alocacao__rotulo ia-texto-auxiliar" },
            [_vm._v(" " + _vm._s(_vm.rotuloEmFoco) + " ")]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }